module.exports = __webpack_public_path__ + "img/r-82.8a9cd4ed.jpg";